import CCTable from './CCTable'

export default CCTable
export * from './CCTable'
